export const GeofenceType = {
  Circle: "C",
  Polygon: "P",
};
